
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import GeneralVehicleSelect from "@common/src/components/scope/vehicle-select/index.vue";
import BtnCheck from "@/components/scope/btn-check.vue";
import BtnCheckGroup from "@common/src/components/scope/btn-check-group/index.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit, isCustomPlateCode, isJingyouvehicleData } from "@common/src/utils/tools";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import CustomerFlagSelect from "@common/src/components/scope/flag-select/index.vue";
import NextMaintenanceDatePicker from "@common/src/components/scope/next-maintenance-datepicker/index.vue";
import NextMileageInput from "@common/src/components/scope/next-mileage-input/index.vue";
import RepeatOrderDialog from "@common/src/components/scope/repeat-order-dialog/index.vue";
import TechnicianTips from "./components/technician-tips.vue";
import TempPurchaseDialog from "@/components/scope/temp-purchase-dialog/index.vue";
import PartsSelector from "@common/src/components/scope/parts-selector/index.vue";
import {
  priceRulesEl,
  mobileRulesEl,
  partsQuantityRules,
  priceRules,
  plateCodeRuleEl,
  isPositiveInteger,
  mileageRulesEl
} from "@common/src/utils/verify";
import _ from "lodash-es";

Component.registerHooks(["beforeRouteLeave"]);
const staff = namespace("staff");
const customer = namespace("customer");
const serviceItem = namespace("service-item");
const service = namespace("service");
const parts = namespace("parts");
const partsCategory = namespace("parts-category");
const user = namespace("user");
const app = namespace("app");
const setting = namespace("setting");
const common_base = namespace("common_base");
const common_app = namespace("common_app");

@Component({
  components: {
    GeneralVehicleSelect,
    BtnCheck,
    BtnCheckGroup,
    MyCheckbox,
    CustomerFlag,
    CustomerFlagSelect,
    NextMaintenanceDatePicker,
    NextMileageInput,
    RepeatOrderDialog,
    TechnicianTips,
    TempPurchaseDialog,
    PartsSelector
  }
})
export default class ServiceEdit extends Vue {
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @staff.Action getTechnicianStaffList;
  @customer.Action getCustomerList;
  @customer.Action getCustomerDetail;
  @customer.Action updateVehicleOwner;
  @serviceItem.Action getServiceItemList;
  @serviceItem.Action getServiceDetail;
  @customer.Action saveCustomer;
  @service.Action createMaintenanceOrder;
  @service.Action getAppointmentCalender;
  @service.Action createWashOrder;
  @service.Action createRetailOrder;
  @service.Action checkRepeatCreateOrder;
  @parts.Action getPartsInventoryList;
  @parts.Action getPartsDetail;
  @service.Action getOrderDetail;
  @service.State technicianTipsAutoShow;
  @service.Mutation setTechnicianTipsAutoShow;
  @service.Action updateOrder;
  @partsCategory.Action getCategoryList;
  @parts.Action createParts;
  @user.State userData;
  @app.State btnLoading;
  @app.State country;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Getter isOpenDispatch;
  @common_base.State showPlatformParts;
  @common_base.State showPlatformServiceItem;
  @common_app.State lang;
  @user.State u8cStore;
  @service.Action preOrderCheckMileage;
  @parts.Action saveTempParts;
  isJingyouvehicleData = isJingyouvehicleData;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    let typeStr = "";
    if (this.orderType === "maintenance") {
      typeStr = t("test.new-maintenance-service");
    }
    if (this.orderType === "wash") {
      typeStr = t("test.new-car-wash-service");
    }
    if (this.orderType === "retail") {
      typeStr = t("test.new-retail-service");
    }
    return [
      { name: t("test.service-management"), path: "/service/index" },
      { name: this.isAdd ? typeStr : t("service.edit-service-information") }
    ];
  }
  get isAdd() {
    return this.$route.name === "serviceAdd";
  }
  get isArriveOperate() {
    return this.$route.query.pageType === "arrive";
  }
  valueMapping: any = {
    "1": "maintenance",
    "2": "wash",
    "3": "retail"
  };
  orderTypeCodeMap: any = {
    maintenance: "1",
    wash: "2",
    retail: "3"
  };
  get orderType() {
    return this.$route.query.type || this.valueMapping[this.orderFormData.orderType];
  }
  showSetArriveStoreDate: boolean = false; // 是否显示设置到店时间
  arriveStoreDate: string = dayjs().format("YYYYMMDD"); // 预约到店时间
  arriveTimeArr: any = [
    ["07", "08"],
    ["08", "09"],
    ["09", "10"],
    ["10", "11"],
    ["11", "12"],
    ["12", "13"],
    ["13", "14"],
    ["14", "15"],
    ["15", "16"],
    ["16", "17"],
    ["17", "18"],
    ["18", "19"],
    ["19", "20"],
    ["20", "21"],
    ["21", "22"]
  ];
  chooseTimeIndex: number = -1;
  todayTimeStamp = dayjs().startOf("day").valueOf();
  disableTimeStamp: number = dayjs().add(2, "month").valueOf();
  datePickerOptions: any = {};
  todayAppointmentData: any = {};
  get arriveTimeDisableArr() {
    return this.arriveTimeArr.map(time => {
      return time[0] <= dayjs().get("hour") && this.arriveStoreDate === dayjs().format("YYYYMMDD");
    });
  }
  getAppointmentData() {
    // 获取预约时间日历数据
    this.getAppointmentCalender().then(data => {
      if (data?.data?.list) {
        this.appointmentData = data.data.list;
      }
      this.handleChooseDate(this.arriveStoreDate);
      this.setPickerOptions();
    });
  }
  get hasAppointmentDate() {
    return this.appointmentData.map(item => item.date);
  }
  setPickerOptions() {
    this.datePickerOptions = {
      disabledDate: val => {
        let timestamp = dayjs(val).valueOf();
        return !(timestamp >= this.todayTimeStamp && timestamp <= this.disableTimeStamp);
      },
      cellClassName: val => {
        if (this.hasAppointmentDate.includes(dayjs(val).format("YYYYMMDD"))) {
          return "point";
        }
        return "";
      }
    };
  }
  handleChooseTime(i, disable) {
    if (disable) return;
    this.chooseTimeIndex = i;
  }
  appointmentData: any = [];
  handleChooseDate(val) {
    this.chooseTimeIndex = -1; // 切换日期清空时间段选择
    this.todayAppointmentData = {};
    let thisDay = this.appointmentData.find(item => {
      return item.date === val;
    });
    if (thisDay) {
      let temp = {};
      thisDay.reservationHours.forEach(item => {
        temp[item.hour] = item.reservationOrderCount;
      });
      this.todayAppointmentData = temp;
    }
  }
  handleAppointment() {
    if (!this.arriveStoreDate || this.chooseTimeIndex < 0) {
      return this.$message.error(t("service.choose-your-arrival-time"));
    }
    this.showSetArriveStoreDate = false;
    let date = this.arriveStoreDate + this.arriveTimeArr[this.chooseTimeIndex][0];
    this.orderFormData.reservationArrivalTime = date;
  }
  handleSettingArriveTime() {
    this.showSetArriveStoreDate = true;
  }
  quitNext: any;
  shwoAddServiceModal: boolean = false; // 快捷添加服务modal框显示/隐藏
  shwoQuitConfirm: boolean = false;
  beforeRouteLeave(to, from, next) {
    if (this.isAdd && to.name !== "serviceView" && this.watchOrderNum > 2) {
      this.shwoQuitConfirm = true;
      this.quitNext = next;
      next(false);
    } else {
      next();
    }
  }
  // 控制form disable状态
  formDisableStatus = {
    plateCode: false,
    customerModelCode: false,
    customerName: false,
    customerMobile: false
  };
  appointmentTimeFromat(time) {
    return `${time.substr(0, 4)}-${time.substr(4, 2)}-${time.substr(6, 2)} ${time.substr(8, 2)}:00 - ${
      Number(time.substr(8, 2)) + 1
    }:00`;
  }
  categoryCasProps: any = {
    label: "categoryName",
    value: "categoryCode"
  };
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  advisorList: any = [{}];
  technicianStaffList: any = [];
  defaultVehicleList: any = [];
  emptyToLine = emptyToLine;
  showSelectCustomer: boolean = false;
  showAdditional: boolean = false;
  orderFormData: any = {
    orderType: "1",
    externalCustomerFlag: "0",
    orderDateType: "1", // 1到店 2预约到店
    reservationArrivalTime: "",
    orderAmount: "0",
    additionalFees: "",
    additionalFeesRemark: "",
    advisorCode: "",
    customerCode: "",
    customerCurrentMileage: "",
    customerMobile: "",
    customerModelCode: "",
    customerName: "",
    customerNextMaintenanceDate: "",
    customerNextMileage: "",
    customerOilVolume: 0,
    leaveTime: dayjs().format("YYYYMMDD"),
    plateCode: "",
    partsDetail: [],
    serviceDetail: [],
    storeRemark: "", // 客户备注
    deliverymanName: "", // 送修人
    deliverymanMobile: "" // 送修人手机号
  };
  get additionalData() {
    return [
      {
        additionalFees: this.orderFormData.additionalFees,
        additionalFeesRemark: this.orderFormData.additionalFeesRemark
      }
    ];
  }
  get customerFormRules() {
    return {
      plateCode: this.plateCodeRules(),
      customerModelCode: this.customerModelRules(),
      customerMobile: this.customerMobileRules(),
      customerName: this.customerNameRules(),
      customerCurrentMileage: {
        required: this.currentMileageNeed ? true : false,
        validator: this.checkMileage,
        trigger: "blur"
      },
      customerNextMileage: { validator: this.checkMileage, trigger: "blur" }
    };
  }
  customerMobileRules() {
    if (this.orderType === "retail" || this.u8cStore) {
      return [{ required: true, validator: this.validateMobile, trigger: "blur" }];
    } else {
      return [];
    }
  }
  customerNameRules() {
    if (this.orderType === "retail" || this.u8cStore) {
      return [{ required: true, validator: this.validateCustomerName, trigger: "blur" }];
    } else {
      return [];
    }
  }
  plateCodeRules() {
    if (this.orderType === "retail" || this.u8cStore) {
      return [{ required: true, validator: this.validatePlateCode, trigger: "blur" }];
    } else {
      return [];
    }
  }
  customerModelRules() {
    if (this.u8cStore || this.orderType !== "retail") {
      return [{ required: true, message: t("test.select-car-model"), trigger: "blur" }];
    } else {
      return [];
    }
  }
  // u8c的店 并且 是到店 或者 有到店时间
  get currentMileageNeed() {
    return this.u8cStore && (!this.isAdd || this.orderFormData.orderDateType === "1");
  }
  checkMileage(rule, value, callback) {
    if (rule.field === "customerCurrentMileage") {
      mileageRulesEl(value, callback, !this.currentMileageNeed);
    } else {
      mileageRulesEl(value, callback, true);
    }
  }
  validateMobile(rule, value, callback) {
    // 如果为空，客户信息没有手机号，做格式效验
    if (this.u8cStore || (value && !this.formDisableStatus.customerMobile)) {
      mobileRulesEl(value, callback);
    } else {
      callback();
    }
  }
  validateCustomerName(rule, value, callback) {
    if (this.u8cStore && !this.orderFormData.customerName) {
      callback(new Error(t("v210831.please-enter-customer")));
    } else {
      callback();
    }
  }
  definitionServiceData: any = {
    serviceCode: "",
    workingHours: "",
    quantity: "", // 次数
    singleWorkingHours: "", // 单次工时
    serviceFee: "", // 服务单价
    amount: "",
    technicianCode: [],
    saleCode: "",
    remark: "",
    manual: true,
    partsList: []
  };
  definitionPartsData: any = {
    partsCode: "",
    partsName: "",
    partsNameDesc: "",
    quantity: "",
    sellingPrice: "",
    technicianCode: [],
    saleCode: "",
    amount: "",
    remark: "",
    manual: true,
    partsRuleType: 1
  };

  serviceItemList: any[] = [];
  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }
  created() {
    this.setPBPX(100);
    this.init();
    this.getAppointmentData();
  }
  async init() {
    await this.getStaffList({
      // 获取所有员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      this.orderFormData.advisorCode = this.userData.userCode;
      this.definitionServiceData.saleCode = this.userData.userCode;
      this.definitionPartsData.saleCode = this.userData.userCode;
    });
    this.getTechnicianStaffList({
      // 获取角色为技师的员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.technicianStaffList = data.data.list;
    });
    if (this.orderType) {
      // 这里有orderType说明是新增
      await this.handleSearchServiceItemList();
    }
    await this.getPartsLists();
    if (!this.isAdd && this.orderId) {
      // 订单编辑
      this.getOrderDetail({
        orderNo: this.orderId,
        modifyFlag: 1
      }).then(async data => {
        const serviceCodeMap = {}; // 存serviceCode和套餐下零配件下索引放映射关系
        for (let pi = 0; pi < data.data.partsDetail.length; pi++) {
          const parts = data.data.partsDetail[pi];
          if (parts.technicianArray) {
            // 格式化技师code
            parts.technicianCode = parts.technicianArray.map(item => item.technicianCode);
          }
          if (parts.serviceCode) {
            if (serviceCodeMap[parts.serviceCode]) {
              serviceCodeMap[parts.serviceCode].push(pi);
            } else {
              serviceCodeMap[parts.serviceCode] = [pi];
            }
          }
          // 单一零配件下拉选项回显并去重
          if (parts.partsRuleType === 1) {
            if (!this.partsList.some(listItem => listItem.partsCode === parts.partsCode)) {
              this.partsList.push({
                partsCode: parts.partsCode,
                partsNameDesc: parts.partsNameDesc
              });
            }
          }
          // 套餐组零配件需要获取自己的可选零配件范围
          if (parts.partsRuleType === 2) {
            this.getPartsLists("", parts);
          } else if (parts.partsRuleType === 3) {
            this.getPartsLists("", parts, [
              {
                partsCode: parts.partsCode,
                partsNameDesc: parts.partsNameDesc
              }
            ]);
          }
        }
        // 编辑 才会在这里拉取服务项目 但是要设置orderType
        this.orderFormData.orderType = data.data.orderType;
        await this.handleSearchServiceItemList();

        data.data.serviceDetail.forEach(serviceItem => {
          if (serviceItem.technicianArray) {
            // 格式化技师code
            serviceItem.technicianCode = serviceItem.technicianArray.map(item => item.technicianCode);
          }
          if (serviceCodeMap[serviceItem.serviceCode]) {
            serviceItem.isGroup = true;
            serviceItem.groupServiceIndex = this.groupIndex;
            serviceCodeMap[serviceItem.serviceCode].forEach(i => {
              const parts = data.data.partsDetail[i];
              parts.isGroupParts = true;
              parts.groupServiceIndex = this.groupIndex;
              parts.servicePriceType = serviceItem.priceType;
              parts.requireQuantity = (parts.quantity / serviceItem.quantity).toFixed(2);
            });
            this.groupIndex++;
          }
          // 服务项目下拉选项回显并去重
          if (!this.serviceItemList.some(listItem => listItem.serviceCode === serviceItem.serviceCode)) {
            this.serviceItemList.push({
              serviceCode: serviceItem.serviceCode,
              serviceName: serviceItem.serviceName
            });
          }
        });
        //油量回显
        data.data.customerOilVolume = Number(data?.data?.customerOilVolume || 0);
        // 客户标签回显
        this.customerLabelDescList = data.data.labelDescList;
        // 整个Data赋值
        this.orderFormData = data.data;
        // disable 已选服务项目
        this.SetServiceItemDisabled();
        this.orderFormData.leaveTime =
          this.orderFormData.leaveTime && dayjs(this.orderFormData.leaveTime).format("YYYYMMDD");
        this.orderFormData.customerNextMaintenanceDate =
          this.orderFormData.customerNextMaintenanceDate &&
          dayjs(this.orderFormData.customerNextMaintenanceDate).format("YYYYMMDD");
        // 附加费
        if (data.data.additionalFees) {
          this.showAdditional = true;
        }
        // 默认车型回显
        this.defaultVehicleList = [
          {
            lastValue: data.data.customerModelCode,
            name: data.data.modelDesc
          }
        ];
        this.formDisableStatus.plateCode = true;
        this.formDisableStatus.customerModelCode = isJingyouvehicleData(data.data.customerModelCode);
        this.formDisableStatus.customerName = !!data.data.customerName;
        this.formDisableStatus.customerMobile = !!data.data.customerMobile;
      });
    } else {
      let customerCode = this.$route.query.customerCode;
      let vehicleCode = this.$route.query.vehicleCode;
      let serviceItemCodes = this.$route.query.serviceItemCodes as any;
      let serviceItemCodeArr = serviceItemCodes ? serviceItemCodes.split(",") : [];
      let partsCodes = this.$route.query.partsCodes as any;
      let partsCodeArr = partsCodes ? partsCodes.split(",") : [];
      serviceItemCodeArr.forEach((item, index) => {
        this.handleAddService();
        this.handleChooseServiceItem(item, index);
      });
      partsCodeArr.forEach((item, index) => {
        this.handleAddParts();
        this.handleChooseParts(item, index);
      });
      if (customerCode) {
        this.setCustomerData(vehicleCode, customerCode);
      }
      if (this.orderType !== "retail" && !serviceItemCodeArr.length && !partsCodeArr.length) {
        this.handleAddService();
      }
    }
  }
  typeOptionsData: any = [
    {
      label: t("service.the-shop-order"),
      value: "1"
    },
    {
      label: t("service.booking-order"),
      value: "2"
    }
  ];
  handleSwitchType(val) {
    if (val === "1") {
      this.orderFormData.reservationArrivalTime = "";
    } else {
      this.orderFormData.leaveTime = "";
    }
  }
  validatePlateCode(rule, value, callback) {
    if (value && isCustomPlateCode(value)) {
      callback();
    } else {
      plateCodeRuleEl(value, callback, this.country);
    }
  }
  // 确认退出
  confirmQuit() {
    this.quitNext();
  }
  getPartsLists(name = "", row?, addRow = []) {
    const params: any = {
      pageNum: 1,
      pageSize: 20,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    };
    if (row && row.partsRuleType !== 1) {
      params.partsRuleType = row.partsRuleType;
      params.partsRuleCode = row.partsRuleCode;
    }
    params.searchKey = name;
    return this.getPartsInventoryList(params).then(data => {
      const list = data.data?.list || [];
      if (row && row.partsRuleType !== 1) {
        // 回显&去重
        addRow = addRow.filter(
          addPrts => addPrts.partsCode && !list.some(listParts => addPrts.partsCode === listParts.partsCode)
        );
        this.$set(row, "partsList", [...list, ...addRow]);
        if (row.partsRuleType === 2 && (list?.length || 0) === 1) {
          Object.assign(row, list[0], {
            partsRuleType: row.partsRuleType,
            sellingPrice: row.sellingPrice,
            partsCode: list[0].partsCode
          });
        }
      } else {
        this.partsList = list;
      }
    });
  }
  computedAmount(type, index, deleteRow?) {
    // type: 1-服务，2-零配件，3-附加费
    if (type === 1) {
      const rowData = this.orderFormData.serviceDetail[index];
      const serviceFee = rowData.serviceFee;
      const quantity = rowData.quantity || 0;
      rowData.amount = (serviceFee * quantity).toFixed(2);
      const serviceCode = rowData.serviceCode;
      this.orderFormData.partsDetail.forEach(parts => {
        if (serviceCode === parts.serviceCode && parts.groupServiceIndex === rowData.groupServiceIndex) {
          parts.quantity = quantity * (parts.requireQuantity || 0);
          parts.amount = parts.quantity * parts.sellingPrice;
        }
      });
    } else if (type === 2) {
      const rowData = deleteRow || this.orderFormData.partsDetail[index];
      if (rowData.isGroupParts) {
        if (rowData.servicePriceType === 1) {
          // 1:固定价格套餐 2: 非固定价格套餐
          rowData.amount = 0;
          return;
        } else if (rowData.servicePriceType === 2) {
          const findService = this.orderFormData.serviceDetail.find(
            service => service.serviceCode === rowData.serviceCode
          );
          const samePackageAmount = this.orderFormData.partsDetail.reduce((prev, curr) => {
            return (
              prev + (curr.serviceCode === rowData.serviceCode ? Number(curr.sellingPrice) * Number(curr.quantity) : 0)
            );
          }, 0);
          findService.serviceFee = (samePackageAmount / findService.quantity).toFixed(2);
          findService.amount = samePackageAmount;
        }
      }
      let amount = (rowData.quantity || 0) * rowData.sellingPrice;
      rowData.amount = amount.toFixed(2);
    }
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const serviceTotal = this.orderFormData.serviceDetail.reduce((preV, curV) => preV + Number(curV.amount), 0);
    const partsTotal = this.orderFormData.partsDetail.reduce(
      (preV, curV) => preV + (curV.isGroupParts ? 0 : Number(curV.amount)),
      0
    );
    if (Object.is(NaN, serviceTotal) || Object.is(NaN, partsTotal)) {
      return this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    this.orderFormData.orderAmount = (serviceTotal + partsTotal + Number(this.orderFormData.additionalFees)).toFixed(2);
  }
  handleSearchServiceItemList(name = "") {
    this.noMatchingServiceItemName = name;
    return this.getServiceItemList({
      pageSize: 20,
      pageNum: 1,
      searchKey: name,
      serviceClass: this.orderType === "maintenance" ? null : "2",
      notOpadmin: this.showPlatformServiceItem ? "0" : "1"
    }).then(data => {
      this.serviceItemList = data.data?.list || [];
      this.SetServiceItemDisabled();
    });
  }
  SetServiceItemDisabled() {
    this.serviceItemList = this.serviceItemList.map(service => {
      service.disabled = this.orderFormData.serviceDetail.some(item => item.serviceCode === service.serviceCode);
      return service;
    });
  }
  groupIndex: number = 1;
  handleChooseServiceItem(val, index) {
    let serviceItemRowData = this.orderFormData.serviceDetail[index];
    this.getServiceDetail({
      serviceCode: val
    }).then(data => {
      const serviceData = data?.data || {};
      Object.assign(serviceData, {
        serviceFee: serviceData.serviceFee,
        partsList: [],
        technicianCode: serviceItemRowData?.technicianCode || [],
        quantity: 1,
        saleCode: this.userData.userCode
      });
      this.orderFormData.serviceDetail.splice(index, 1, serviceData);
      // 套餐项目，并且有零配件
      if (serviceData.serviceType === "2" && serviceData.servicePartsList.length > 0) {
        let _index = (serviceData.groupServiceIndex = this.groupIndex);
        const partsCodeArr = serviceData.servicePartsList.map(parts => parts.partsCode);
        const partsRequireNum = serviceData.servicePartsList.map(parts => parts.servicePartsQty);
        this.getPartsInventoryList({
          partsCodes: partsCodeArr,
          pageSize: 999,
          partsRuleTypeList: [1, 2, 3]
        }).then(data => {
          const partsArr = data.data?.list || [];
          partsArr.forEach((parts, parstIndex) => {
            const partsOriginData = serviceData.servicePartsList?.[parstIndex] || {};
            const findeItem = partsArr.find(item => partsOriginData.partsCode === item.partsCode);
            let partsData = Object.assign({}, this.definitionPartsData, findeItem, partsOriginData, {
              isGroupParts: true,
              servicePriceType: serviceData.priceType,
              saleCode: "",
              quantity: partsRequireNum[parstIndex],
              requireQuantity: partsRequireNum[parstIndex],
              partsCode: partsOriginData.partsRuleType === 1 ? partsOriginData.partsCode : "", // 如果是单一零配件默认partsCode，组则为“”
              serviceCode: val,
              groupServiceIndex: _index,
              partsList: [],
              amount: 0
            });

            if (partsData.partsRuleType !== 1) {
              this.getPartsLists("", partsData);
            }

            this.orderFormData.partsDetail.push(partsData);
            serviceItemRowData.partsList && serviceItemRowData.partsList.push(partsData);
          });
        });
        this.groupIndex++;
      }
      // 添加到服务项列表回显并去重
      if (!this.serviceItemList.some(serviceItem => serviceItem.serviceCode === serviceData.serviceCode)) {
        this.serviceItemList.push(serviceData);
      }
      this.SetServiceItemDisabled();
      this.clearParts();
      this.computedAmount(1, index);
    });
  }
  clearParts() {
    // 清除未匹配的套餐零配件
    const selectedServiceGroupIndexArr = this.orderFormData.serviceDetail.map(item => {
      return item.groupServiceIndex;
    });
    for (let partsIndex = 0; partsIndex < this.orderFormData.partsDetail.length; partsIndex++) {
      let currentParts = this.orderFormData.partsDetail[partsIndex];
      // 是套餐中的零配件，并且下标在项目中不存在
      if (currentParts.serviceCode && !selectedServiceGroupIndexArr.includes(currentParts.groupServiceIndex)) {
        this.orderFormData.partsDetail.splice(partsIndex, 1);
        partsIndex--;
      }
    }
  }
  async handleChooseParts(partsCode, index) {
    let partsData = {};
    let partsRowData = this.orderFormData.partsDetail[index];
    let findParts: any = {};
    if (partsRowData.partsRuleType === 1) {
      // 正常零配件
      findParts = this.partsList.find(item => item.partsCode === partsCode);
    } else {
      // 零配件组
      findParts = (partsRowData?.partsList || []).find(item => item.partsCode === partsCode);
    }
    if (findParts) {
      if (partsRowData.partsRuleType === 1) {
        partsData = Object.assign({}, partsRowData, findParts);
      } else {
        // 零配件组需要保留 partsRuleType isGroup  等字段, 零配件组非固定价格的零配件价格要从partsRowData?.partsList中取.
        partsData = Object.assign({}, partsRowData, findParts, {
          sellingPrice: findParts.sellingPrice,
          partsRuleType: partsRowData.partsRuleType
        });
      }
    } else {
      partsData = await this.getPartsInventoryList({
        partsCodes: [partsCode],
        pageSize: 999,
        partsRuleTypeList: [1, 2, 3]
      }).then(data => {
        let parts = data.data.list?.[0] || undefined;
        if (parts) {
          parts.isGroupParts = false;
          this.partsList.push(parts);
        } else {
          parts = Object.assign({}, this.definitionPartsData);
        }
        return parts;
      });
    }
    this.orderFormData.partsDetail.splice(index, 1, partsData);
    this.computedAmount(2, index);
  }
  submitForm() {
    if (!this.orderFormData.customerCode) {
      this.$message.error(t("test.search-select-customer"));
      return;
    }
    if (this.u8cStore) {
      if (this.isAdd) {
        if (!this.seletedVehiCleData.vinCode) {
          this.seletedCustomer = "";
          return this.$message.error(t("v216_6.vin-code-tips"));
        }
      } else {
        if (!this.orderFormData.vinCode) {
          return this.$message.error(t("v216_6.vin-code-tips"));
        }
      }
    }
    (this.$refs["customerForm"] as any).validate(async valid => {
      if (valid && this.checkAddData()) {
        if (this.isAdd) {
          this.checkLastOrderData = await this.beforeSubmitCheck();
          if (!this.checkLastOrderData) {
            this.createService();
          }
        } else {
          this.editService();
        }
      } else {
        console.log("error submit!!");
      }
    });
  }
  checkLastOrderData: any = {};
  beforeSubmitCheck() {
    return this.checkRepeatCreateOrder({
      mobile: this.orderFormData.customerMobile,
      orderType: this.orderTypeCodeMap[this.orderType],
      plateCode: this.orderFormData.plateCode
    }).then(data => {
      return data.data;
    });
  }
  beforeSaveOrder() {
    const params = {
      ..._.pick(this.orderFormData, [
        "customerCurrentMileage",
        "customerNextMaintenanceDate",
        "customerNextMileage",
        "plateCode",
        "customerOilVolume",
        "vehicleCode"
      ]),
      orderNo: this.orderId
    };
    return this.preOrderCheckMileage(params).then(
      () => {
        return true;
      },
      res => {
        if (res.code === "speedbiz.system.vehicle-last-maintenance-mileage-error") {
          return this.$confirm(res.message, t("v210831.tips"), {
            confirmButtonText: t("v216_6.continue-saving"),
            cancelButtonText: t("base.cancel"),
            type: "warning"
          });
        } else {
          return true;
        }
      }
    );
  }
  checkAddData(): boolean {
    if (this.orderFormData.orderDateType === "2" && !this.orderFormData.reservationArrivalTime) {
      this.$message.error(t("service.appointment-your-arrival-time"));
      return false;
    }
    if (this.orderFormData.storeRemark && this.orderFormData.storeRemark.length > 50) {
      this.$message.error(t("v213.store-remarks-can-be-up-to-characters-long"));
      return false;
    }

    if (this.orderType !== "retail" && this.orderFormData.serviceDetail.length < 1) {
      this.$message.error(t("service.add-least-service-item"));
      return;
    }
    for (let index = 0; index < this.orderFormData.serviceDetail.length; index++) {
      const element = this.orderFormData.serviceDetail[index];
      if (!element.serviceCode) {
        this.$message.error(t("service.select-service-item"));
        return false;
      }
      if (!element.quantity || !isPositiveInteger(element.quantity)) {
        this.$message.error(t("v270.the-number-of-items-must-be-a-positive"));
        return false;
      }
      if (!element.amount) {
        this.$message.error(t("setting.enter-hourly-rate"));
        return false;
      }
      if (
        !this.isOpenDispatch &&
        this.orderType !== "wash" &&
        (this.orderFormData.orderDateType === "1" || this.isArriveOperate) &&
        element.technicianCode &&
        element.technicianCode.length === 0
      ) {
        this.$message.error(t("service.select-service-technician"));
        return false;
      }
    }
    if (this.orderType === "retail" && this.orderFormData.partsDetail.length < 1) {
      this.$message.error(t("service.add-least-one-widget"));
      return;
    }
    for (let index = 0; index < this.orderFormData.partsDetail.length; index++) {
      const parts = this.orderFormData.partsDetail[index];
      if (parts.partsType !== "2" && !parts.partsCode && parts.partsRuleType === 1) {
        this.$message.error(t("setting.select-spare-parts"));
        return false;
      }
      if (!parts.quantity) {
        this.$message.error(t("service.fill-number-spare-parts"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(parts.quantity);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (!parts.isGroupParts && !parts.sellingPrice) {
        this.$message.error(t("service.fill-unit-price-spare-parts"));
        return false;
      }
    }
    if (this.orderFormData.additionalFees && !priceRules(this.orderFormData.additionalFees).success) {
      this.$message.error(t("service.input-additional-fee-format"));
      return false;
    }
    return true;
  }
  customerLabelDescList: any = [];
  saveCustomerInfo() {
    const customerSaveData = {
      customerCode: this.orderFormData.customerCode,
      vehicle: {
        vehicleCode: this.orderFormData.vehicleCode,
        plateCode: this.orderFormData.plateCode,
        modelCode: this.orderFormData.customerModelCode,
        labelDescList: this.customerLabelDescList
      },
      customerName: this.orderFormData.customerName,
      mobile: this.orderFormData.customerMobile
    };
    this.btnStartLoading();
    return this.saveCustomer(customerSaveData)
      .then(() => {})
      .catch(e => {
        const errCode = e.code;
        if (errCode === "speedbiz.system.duplicated-customer-mobile-error") {
          console.log("弹框提示转移车主");
          this.$confirm(
            "手机号系统已存在，是否一键带入原手机号客户信息，确定保存后即修改为填入的手机号。",
            "提示"
          ).then(
            async () => {
              const { vehicleCode, customerMobile } = this.orderFormData;
              const customerRes = await this.getCustomerDetail({
                mobile: customerMobile
              });
              const { customerCode, customerName, mobile } = customerRes.data;
              await this.updateVehicleOwner({
                vehicleCode,
                customerCode,
                mobile
              });
              this.orderFormData.customerName = customerName;
              this.orderFormData.customerMobile = mobile;
              this.orderFormData.customerCode = customerCode;
            },
            () => {}
          );
        }
        return Promise.reject();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  async createService() {
    let result;
    try {
      await this.saveCustomerInfo();
      this.setTechnicianArray(); // 技师Code format成对象数组
      this.btnStartLoading();
      await this.beforeSaveOrder();
      if (this.orderType === "maintenance") {
        result = await this.createMaintenanceOrder(this.orderFormData);
      } else if (this.orderType === "wash") {
        result = await this.createWashOrder(this.orderFormData);
      } else {
        result = await this.createRetailOrder(this.orderFormData);
      }
      this.$message.success(t("base.create-success") as string);
      this.$router.push(`/service/view/${result.data.orderNo}`);
      this?.quitNext();
    } catch (e) {
      this.btnStopLoading();
    }
  }
  setTechnicianArray() {
    this.orderFormData.serviceDetail.forEach(serviceItem => {
      serviceItem.technicianArray = (serviceItem?.technicianCode || []).map(item => ({
        technicianCode: item
      }));
      serviceItem.technicianCodes = (serviceItem?.technicianCode || []).join();
    });
    this.orderFormData.partsDetail.forEach(serviceItem => {
      serviceItem.technicianArray = (serviceItem?.technicianCode || []).map(item => ({
        technicianCode: item
      }));
      serviceItem.technicianCodes = (serviceItem?.technicianCode || []).join();
    });
  }
  async editService() {
    await this.saveCustomerInfo();
    if (this.isArriveOperate) {
      this.orderFormData.arrivalStore = true;
    }
    this.btnStartLoading();
    this.setTechnicianArray();
    try {
      await this.beforeSaveOrder();
      this.updateOrder(this.orderFormData)
        .then(() => {
          this.$message.success(t("base.update-success") as string);
          this.$router.push(`/service/view/${this.orderId}`);
        })
        .finally(() => {
          this.btnStopLoading();
        });
    } catch (e) {
      this.btnStopLoading();
    }
  }
  addAdditionCost() {
    // 控制表格显示
    this.showAdditional = true;
  }
  handleAddService() {
    let technicianArray = [];
    if (
      this.orderFormData?.serviceDetail?.[0]?.technicianCode &&
      this.orderFormData.serviceDetail[0].technicianCode.length > 0
    ) {
      technicianArray = this.orderFormData.serviceDetail[0].technicianCode.slice();
    }
    this.orderFormData.serviceDetail.push(
      Object.assign({}, this.definitionServiceData, {
        technicianCode: technicianArray
      })
    );
  }
  handleAddParts(tempData?) {
    let technicianArray = [];
    if (
      this.orderFormData?.serviceDetail?.[0]?.technicianCode &&
      this.orderFormData.serviceDetail[0].technicianCode.length > 0
    ) {
      technicianArray = this.orderFormData.serviceDetail[0].technicianCode.slice();
    }
    this.orderFormData.partsDetail.push(
      Object.assign({}, this.definitionPartsData, {
        technicianCode: technicianArray,
        ...(tempData || {})
      })
    );
  }
  handleLinkAddParts() {
    const { href } = this.$router.resolve("/setting/parts-add");
    window.open(href);
  }
  deleteItem(key, index) {
    if (key === "serviceDetail") {
      const row = this.orderFormData.serviceDetail[index];
      if (row.groupServiceIndex) {
        let service = row;
        for (let partsIndex = 0; partsIndex < this.orderFormData.partsDetail.length; partsIndex++) {
          let parts = this.orderFormData.partsDetail[partsIndex];
          if (parts.groupServiceIndex === service.groupServiceIndex) {
            this.orderFormData.partsDetail.splice(partsIndex, 1);
            partsIndex--;
          }
        }
      }
      this.orderFormData[key].splice(index, 1);
      this.computedTotalAmount();
    } else {
      const row = _.clone(this.orderFormData.partsDetail[index]);
      this.orderFormData[key].splice(index, 1);
      this.computedAmount(2, index, row);
    }
    this.SetServiceItemDisabled();
  }
  deleteAdditional() {
    this.showAdditional = false;
    this.orderFormData.additionalFees = "";
    this.orderFormData.additionalFeesRemark = "";
  }
  linkCreateCustomer() {
    let { href } = this.$router.resolve({
      path: `/setting/customer-add`
    });
    window.open(href, "_blank");
  }

  seletedCustomer: string = "";
  customerList: any[] = [];
  handleShowSelCustomer() {
    this.showSelectCustomer = true;
    this.$nextTick(() => {
      (this.$refs["select-customer"] as any).focus();
    });
  }
  handleSearchCustomer(val) {
    if (val) {
      this.getCustomerList({
        pageSize: 20,
        pageNum: 1,
        searchKey: val
      }).then(data => {
        if (!data.data.list) {
          this.customerList = [];
        } else {
          this.customerList = data.data.list.map(item => {
            item.label = `${item.plateCode}${item.customerName ? "/" + item.customerName : ""} ${
              item.mobile ? "/" + item.mobile : ""
            }`;
            return item;
          });
        }
      });
    } else {
      this.customerList = [];
    }
  }
  handleChooseCustomer(val) {
    const customer = this.customerList.find(item => {
      return val === item.vehicleCode;
    });

    this.orderFormData.customerCode = customer?.customerCode || "";
    this.setCustomerData(val, customer?.customerCode);
  }
  seletedVehiCleData: any = {};
  setCustomerData(vehicleCode, customerCode) {
    this.getCustomerDetail({
      customerCode: customerCode,
      vehicleCode: vehicleCode
    }).then(data => {
      const customerData = data.data;
      let vehicleList = data.data.vehicleList || [];
      let vehicleData = vehicleList.find(item => {
        return data.data.selectedVehicleCode === item.vehicleCode;
      });
      if (!vehicleData) {
        // 没传车辆code取第一辆
        vehicleData = vehicleList[0] || {};
        vehicleCode = vehicleData.vehicleCode;
      }
      this.seletedVehiCleData = vehicleData;
      this.orderFormData.customerCode = customerCode;
      this.orderFormData.customerName = customerData?.customerName || "";
      this.orderFormData.customerMobile = customerData?.mobile || "";
      this.orderFormData.vehicleCode = vehicleCode;
      this.formDisableStatus.customerName = !!customerData.customerName;
      this.formDisableStatus.customerMobile = !!customerData.mobile;

      if (vehicleData) {
        this.orderFormData.plateCode = vehicleData.plateCode || "";
        this.defaultVehicleList = this.vehicleDataFormat([vehicleData]);
        this.orderFormData.customerCurrentMileage = vehicleData.lastMaintenanceMileage || "";
        this.orderFormData.customerNextMileage = vehicleData.nextMaintenanceMileage || "";
        this.orderFormData.customerNextMaintenanceDate = vehicleData.nextMaintenanceDate || "";
        this.formDisableStatus.plateCode = !!vehicleData.plateCode;
        this.customerLabelDescList = vehicleData.labelDescList; // 客户标签回显
      }
      this.formDisableStatus.customerModelCode =
        !!this.defaultVehicleList.length && isJingyouvehicleData(vehicleData.modelCode);
      // 获取到车辆信息重新验证格式
      if (this.defaultVehicleList.length) {
        this.$nextTick(() => {
          (this.$refs["customerForm"] as any).validateField("customerModelCode");
        });
      }
      if (this.orderFormData.plateCode) {
        this.$nextTick(() => {
          (this.$refs["customerForm"] as any).validateField("plateCode");
        });
      }
    });
  }
  vehicleDataFormat(data) {
    const tempArr = [];
    data.forEach(item => {
      if (item.brandCode && item.seriesName && item.modelCode) {
        tempArr.push({
          lastValue: item.modelCode,
          name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
          valueGroup: [item.brandCode, item.seriesName, item.modelCode]
        });
      }
    });
    return tempArr;
  }
  handleOpoColse() {
    // 关闭去掉错误状态
    (this.$refs["customerForm"] as any).validateField("customerModelCode");
  }
  watchOrderNum = 0;
  @Watch("orderFormData", { deep: true })
  WatchOrderData() {
    this.watchOrderNum += 1;
  }
  getIsPushMoney(serviceCode, list) {
    // 是否是提成项目或者零配件
    if (serviceCode) {
      let res = list.find(item => serviceCode === item.serviceCode || serviceCode === item.partsCode);
      if (res && res.existCommission === "1") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  handleOpServiceItemShowChange() {
    this.handleSearchServiceItemList();
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  handleConfirmCreateOrder() {
    this.checkLastOrderData = {};
    this.createService();
  }
  noMatchingServiceItemName = "";
  handleLinkQuickAddServiceItem() {
    const href = this.$router.resolve(
      `/setting/service-add?serviceItemName=${encodeURIComponent(this.noMatchingServiceItemName)}`
    ).href;
    window.open(href);
  }
  handleTechnicianVisibleChange(visible, refKey, value) {
    if (!visible && value.length > 0 && this.technicianTipsAutoShow) {
      (this.$refs[refKey] as any).open();
      this.setTechnicianTipsAutoShow(false);
    }
  }

  handleTempSubmit(data) {
    this.saveTempParts(data).then(res => {
      const partsItem = {
        partsNameDesc: data.partsName,
        partsCode: res.data.partsCode,
        partsType: "2",
        sellingPrice: data.sellingPrice
      };
      this.partsList.push(partsItem);
      const pLength = this.orderFormData.partsDetail.length;
      if (this.orderFormData.partsDetail?.[pLength - 1]?.partsCode) {
        this.handleAddParts(partsItem);
      } else {
        this.orderFormData.partsDetail.splice(pLength - 1, 1);
        this.handleAddParts(partsItem);
      }
    });
  }
  handleShowTempPurchase() {
    (this.$refs["tempPurDialog"] as any).open();
  }
  formatOilNumber(val) {
    return val * 20 + "%";
  }
  handleToVehicleQuery() {
    const modelCode = this.isAdd ? this.seletedVehiCleData.modelCode : this.orderFormData.customerModelCode;
    const vehicleCode = this.isAdd ? this.seletedVehiCleData.vehicleCode : this.orderFormData.vehicleCode;
    if (modelCode) {
      if (isJingyouvehicleData(modelCode)) {
        const { href } = this.$router.resolve(
          `/guidance/index?customerCode=${this.orderFormData.customerCode}&vehicleCode=${vehicleCode}`
        );
        window.open(href);
      } else {
        this.$confirm(t("v218_0.the-car-model-data-has-been-car-model"), t("v210831.tips"), {
          confirmButtonText: t("v218_0.go-to-edit-clients")
        }).then(() => {
          const { href } = this.$router.resolve(
            `/setting/customer-edit/${this.orderFormData.customerCode}?vehicleCode=${vehicleCode}`
          );
          window.open(href);
        });
      }
    } else {
      const { href } = this.$router.resolve(`/guidance/index?modelData=`);
      window.open(href);
    }
  }
}
